import React, { useEffect, useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import Swal from 'sweetalert2';
import "../../Styles/Faculty/facultyfeedback.css";

const FacultyFeedbackForm = () => {
  const [options, setOptions] = useState([]);
  const [fields, setFields] = useState([
    { name: "", parameter: "", details: "", date: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Helper function to format the date in 'YYYY-MM-DDTHH:MM:SS+05:30'
  const formatToIST = (date) => {
    const inputDate = new Date(date); // Parse the input date
    const offset = 5.5 * 60 * 60 * 1000; // Add 5 hours and 30 minutes
    const istDate = new Date(inputDate.getTime() + offset);

    // Format to 'YYYY-MM-DDTHH:MM:SS+05:30'
    const formattedDate = istDate.toISOString().slice(0, 19); // Remove milliseconds
    return `${formattedDate}+05:30`;
  };

  const handleChange = (index, field, value) => {
    const newFields = [...fields];
    newFields[index][field] = value;
    setFields(newFields);
  };

  const addMoreFields = () => {
    setFields([...fields, { name: "", parameter: "", details: "", date: "" }]);
  };

  const handleSubmit = async () => {
    // Validate fields
    const hasEmptyFields = fields.some(
      (field) => !field.name || !field.parameter || !field.details || !field.date
    );

    if (hasEmptyFields) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please fill in all fields before submitting.',
      });
      return;
    }

    // Format all date fields to 'YYYY-MM-DDTHH:MM:SS+05:30'
    const formattedFields = fields.map((field) => ({
      ...field,
      date: field.date ? formatToIST(field.date) : "", // Format date to IST
    }));

    setLoading(true);
    try {
      await axiosInstance.post("feedback/submit", { data: formattedFields });
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Form submitted successfully!',
        timer: 2000,
        showConfirmButton: false,
      });
      // Reset form
      setFields([{ name: "", parameter: "", details: "", date: "" }]);
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Submission Failed',
        text: error.response?.data?.message || 'Failed to submit form. Please try again.',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Fetch dropdown options from backend
    const fetchOptions = async () => {
      try {
        const response = await axiosInstance.get("feedback/names");
        setOptions(response.data?.data || response.data || []);
        setError(null);
      } catch (error) {
        setError('Failed to load dropdown options. Some features may not work properly.');
        // Set empty array to prevent crashes
        setOptions([]);
      }
    };

    fetchOptions();
  }, []);

  return (
    <div className="faclity-feed-container">
      {error && (
        <div style={{
          padding: '12px 16px',
          marginBottom: '20px',
          background: '#fef2f2',
          border: '2px solid #fecaca',
          borderRadius: '8px',
          color: '#991b1b',
          fontSize: '14px',
          fontWeight: '500'
        }}>
          ⚠️ {error}
        </div>
      )}

      <div className='faclity-feed-drop-top'>
        <select
          className="faclity-feed-dropdown"
          value={fields[0].name}
          onChange={(e) => handleChange(0, "name", e.target.value)}
        >
          <option value="">Select Name</option>
          {options.map((option, idx) => (
            <option key={option.id || idx} value={option.name}>
              {option.name}
            </option>
          ))}
        </select>
      </div>

      {fields.map((field, index) => (
        <div className="faclity-feed-row" key={index}>
          <select
            className="faclity-feed-dropdown"
            value={field.parameter}
            onChange={(e) => handleChange(index, "parameter", e.target.value)}
          >
            <option value="">Select Parameter</option>
            {options.map((option, idx) => (
              <option key={option.id || idx} value={option.name}>
                {option.name}
              </option>
            ))}
          </select>

          <input
            type="text"
            className="faclity-feed-details"
            placeholder="Enter Details"
            value={field.details}
            onChange={(e) => handleChange(index, "details", e.target.value)}
          />

          <input
            type="date"
            className="faclity-feed-date-picker"
            value={field.date}
            onChange={(e) => handleChange(index, "date", e.target.value)}
          />
        </div>
      ))}

      <button className="faclity-feed-add-button" onClick={addMoreFields}>Add More</button>
      <button 
        className="faclity-feed-submit-button" 
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? 'Submitting...' : 'Submit'}
      </button>
    </div>
  );
};

export default FacultyFeedbackForm;
